import styled from 'styled-components';

export const Container = styled.ul`
  width: 100%;
  float: none;
  list-style: none;
  position: relative;
  margin-top: 10px;
  text-align: left;
  height: auto;
  flex: 1;

  //The Magic
  [id^='tab']:checked + label {
    top: 0;
    /* padding-top: 17px; */
    /* background: ${props => props.theme.cardBackgroud}; */
    opacity: 1;
  }
  [id^='tab']:checked ~ [id^='tab-content'] {
    display: block;
  }
`;

export const TabItem = styled.li`
  float: left;
  display: block;

  input[type='radio'] {
    position: absolute;
    top: 0;
    left: -9999px;
    border: 1px solid red;
  }
`;

interface TabNameProps {
  count?: number;
}
export const TabName = styled.label<TabNameProps>`
  display: flex;
  flex-direction: row;
  padding: 7px 21px;
  border-radius: 5px 5px 0 0;
  align-items: center;
  /* border: 1px solid orange; */
  font-size: 0.9rem;
  font-weight: 400;
  text-transform: uppercase;
  background: ${props => props.theme.cardBackgroud};
  color: ${props => props.theme.fontColor};
  opacity: 0.5;
  cursor: pointer;
  position: relative;
  top: 4px;
  transition: all 0.2s ease-in-out;
  &:hover {
    background: ${props => props.theme.cardBackgroud};
    opacity: 0.7;
  }
  span {
    background: ${props =>
      props.count === 0
        ? props.theme.notification.empty
        : props.theme.notification.new};
    margin-left: 5px;
    color: ${props => props.theme.lightFontColor};
    height: 20px;
    width: 20px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

interface TabContentProps {
  height?: string;
}
export const TabContent = styled.div<TabContentProps>`
  border: 2px solid ${props => props.theme.cardBorder};
  z-index: 2;
  display: none;
  overflow: hidden;

  height: ${props => (props.height ? props.height : 'calc(100% - 35px)')};

  width: 100%;
  font-size: 17px;
  line-height: 25px;
  padding: 15px;
  position: absolute;
  /* top: 53px; */
  left: 0;
  background: ${props => props.theme.cardBackgroud};
  box-shadow: 0 1px 20px 0 rgb(0, 0, 0, 0.1%);
  border-radius: 0 5px 5px 5px;
`;
